import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";
/**
 * Component: Free shipping notification script
 * ------------------------------------------------------------------------------
 * A re-usable snippet to display the amount left to spend for free shipping.
 * - This is purely cosmetic and does not control the shipping rates in the admin.
 *
 * @namespace freeShippingNotification
 */

import { formatMoney } from '@shopify/theme-currency';
/**
 * DOM selectors.
 */

const selectors = {
  progressBar: '[js-free-shipping-notification="progressBar"]',
  text: '[js-free-shipping-notification="text"]'
};
/**
 * Create a new free shipping notification object.
 */

export default (() => {
  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    progressBar: [...document.querySelectorAll(selectors.progressBar)],
    text: [...document.querySelectorAll(selectors.text)]
  };
  /**
   * Initialise component.
   */

  function init() {
    setEventBusListeners();
  }
  /**
   * Set listeners to update on every cart change.
   */


  function setEventBusListeners() {
    Frame.EventBus.listen('AjaxCart:updated', response => update(response.total_price));
  }
  /**
   * Update free shipping notification.
   * @param {Number} total - Value to compare threshold against.
   */


  function update(total) {
    render(total);

    if (theme.features.currencyConverter) {
      Frame.EventBus.emit('Currency:convertAll');
    }
  }
  /**
   * Update notification template using new values.
   * @param {Number} total - Current cart total.
   */


  function render(total) {
    const threshold = getThreshold();
    const difference = threshold - total;
    const messages = theme.freeShipping.messages;
    const progress = 100 - difference / threshold * 100;

    if (difference <= 0) {
      nodeSelectors.text.forEach(element => element.innerHTML = messages.ideal);

      if (theme.freeShipping.progressBar) {
        nodeSelectors.progressBar.forEach(element => {
          element.style.maxWidth = "100%";
        });
      }

      return;
    }

    if (total < threshold && total > 0) {
      nodeSelectors.text.forEach(element => {
        element.innerHTML = messages.partial.replace('#value#', getValueTemplate(difference));
      });

      if (theme.freeShipping.progressBar) {
        nodeSelectors.progressBar.forEach(element => {
          element.style.maxWidth = "".concat(progress, "%");
        });
      }

      return;
    }

    nodeSelectors.text.forEach(element => {
      element.innerHTML = messages.blank.replace('#value#', getValueTemplate(threshold));
    });

    if (theme.freeShipping.progressBar) {
      nodeSelectors.progressBar.forEach(element => {
        element.style.maxWidth = "0%";
      });
    }
  }
  /**
   * Get value template with currency data selectors.
   * @param {Number} price - Price to store in price data attribute.
   * @returns {String}
   */


  function getValueTemplate(price) {
    return "<span js-currency=\"price\" data-price=\"".concat(price, "\">").concat(getFormattedCurrency(price), "</span>");
  }
  /**
   * Get formatted currency.
   * @param {Number} cents - Raw amount to convert before formatting.
   * @returns {String}
   */


  function getFormattedCurrency(cents) {
    return formatMoney(cents, theme.moneyFormat);
  }
  /**
   * Get free shipping threshold value.
   * @returns {Number}
   */


  function getThreshold() {
    if (typeof theme.freeShipping.threshold !== 'number') {
      return Number(theme.freeShipping.threshold);
    }

    return theme.freeShipping.threshold;
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init
  });
});